import { createSlice } from "@reduxjs/toolkit";

export const mmymSlice = createSlice({
  name: "mmym",
  initialState: {
    toast: {
      message: "",
      appearance: "error",
    },
    isLoader: false,
    notification: {
      message: [],
      severity: "info",
    },
    searchParams: {
      page: "",
      searchString: "",
      filterStatus: "",
      searchOption: "",
    },
    imageUploadKey: {
      url: "",
      key: "",
    },
    publicUrl: "",
    isValidPostcode: false,
    notificationMessageList: [],
    assignNotificationMessageList: [],
    leadNotificationMessageList: [],
    isWelcomeClosed: false,
  },
  reducers: {
    setToastAction: (state, { payload }) => {
      state.toast = payload || { message: "", appearance: "error" };
    },
    setLoaderAction: (state, { payload }) => {
      state.isLoader = payload || false;
    },
    setNotificationAction: (state, { payload }) => {
      state.notification = payload || { message: [], severity: "info" };
    },
    setSearchParamsAction: (state, { payload }) => {
      state.searchParams = payload || {
        page: "",
        searchString: "",
        filterStatus: "",
        searchOption: "",
      };
    },

    getUploadKeyAction: (state, { payload }) => {
      state.publicUrl = "";
    },
    setUploadKeyAction: (state, { payload }) => {
      // state.imageUploadKey = payload
    },

    getNotificationMessageAction: (state) => {},
    setNotificationMessageAction: (state, { payload }) => {
      state.notificationMessageList = payload;
    },

    getAssignNotificationMessageAction: (state, payload) => {},
    setAssignNotificationMessageAction: (state, { payload }) => {
      state.assignNotificationMessageList = payload;
    },

    getLeadNotificationMessageAction: (state) => {},
    setLeadNotificationMessageAction: (state, { payload }) => {
      state.leadNotificationMessageList = payload;
    },

    putUploadFileAction: (state, { payload }) => {
      state.publicUrl = "";
    },
    setUploadFileAction: (state, { payload }) => {
      state.imageUploadKey = payload;
      state.publicUrl = payload.publicUrl;
    },

    checkValidPostcodeAction: (state, { payload }) => {},
    setCheckValidPostcodeAction: (state, { payload }) => {
      state.isValidPostcode = payload;
    },

    getWelcomeClosedAction: (state) => {},
    setWelcomeClosedAction: (state, { payload }) => {
      state.isWelcomeClosed = payload;
    },
  },
});

const {
  setToastAction,
  setLoaderAction,
  setNotificationAction,
  getAssignNotificationMessageAction,
  setAssignNotificationMessageAction,
  getLeadNotificationMessageAction,
  setLeadNotificationMessageAction,
  setSearchParamsAction,
  getUploadKeyAction,
  setUploadKeyAction,
  putUploadFileAction,
  setUploadFileAction,
  checkValidPostcodeAction,
  setCheckValidPostcodeAction,
  getNotificationMessageAction,
  setNotificationMessageAction,
  getWelcomeClosedAction,
  setWelcomeClosedAction,
} = mmymSlice.actions;

export {
  setToastAction,
  setLoaderAction,
  setNotificationAction,
  getAssignNotificationMessageAction,
  setAssignNotificationMessageAction,
  getLeadNotificationMessageAction,
  setLeadNotificationMessageAction,
  setSearchParamsAction,
  getUploadKeyAction,
  setUploadKeyAction,
  putUploadFileAction,
  setUploadFileAction,
  checkValidPostcodeAction,
  setCheckValidPostcodeAction,
  getNotificationMessageAction,
  setNotificationMessageAction,
  getWelcomeClosedAction,
  setWelcomeClosedAction,
};

export default mmymSlice.reducer;
